const MessageDeliveryStatusLabel = Object.freeze({
  failed: 'MessageDeliveryStatus_Failed',
  sent: 'MessageDeliveryStatus_Sent',
  delivered: 'MessageDeliveryStatus_Delivered',
  bounced: 'MessageDeliveryStatus_Bounced',
  control_group: 'MessageDeliveryStatus_ControlGroup',
  queued: 'MessageDeliveryStatus_Queued',
  processed: 'MessageDeliveryStatus_Processed'
})

const MessageDeliveryStatusEnum = Object.freeze({
  FAILED: 'failed',
  SENT: 'sent',
  DELIVERED: 'delivered',
  BOUNCED: 'bounced',
  CONTROL_GROUP: 'control_group',
  QUEUED: 'queued',
  PROCESSED: 'processed'
})

export { MessageDeliveryStatusLabel, MessageDeliveryStatusEnum }



// WEBPACK FOOTER //
// ./src/common/enum/MessageDeliveryStatusEnum.js